'use client'

import type { FC } from 'react'
import { type CategoryDTO, type Currency, type Option } from 'ecosystem'
import { useSelector } from 'shared-redux'
import { selectedProductState } from 'shared-redux/state'
import { useGtmViewItemListTracker } from '../hooks/useGtmViewItemListTracker'

interface GtmViewItemListTrackerProps {
  id: string
  categories: Option<CategoryDTO[]>
  currency: Currency
  name: string
  isLoading?: boolean
}

export const GtmViewItemListTracker: FC<GtmViewItemListTrackerProps> = ({
  id,
  categories,
  currency,
  isLoading,
  name
}) => {
  const productsState = useSelector(selectedProductState)

  useGtmViewItemListTracker({
    categories,
    id,
    products: productsState.content ?? undefined,
    currency,
    listName: name,
    isLoading: isLoading || productsState.productsListId !== id
  })

  return null
}
